<script>
  import { selectedChannelId } from '../../../Store/store';
  import {
    updateProfileFunFactList,
    listenToChannel,
    updateProfileTagList,
    updateProfileExcludeTagList,
    updateProfileSportsIdText,
    updateProfileSportsNamePathText,
    removeMappingfunFact,
    removeMappingTag,
    removeMappingExcludingTag,
  } from '../../../Api/profilesApi';

  let ffList = [];
  let tagList = [];
  let tagExList = [];
  let sportsId;
  let sportsPath;
  let inputEl;
  let inputElTag;
  let inputElExTag;
  let inputElSportsId;
  let inputElSportNamePath;
  let selected;

  $: $selectedChannelId && getChannelData();

  const getChannelData = async () => {
    await listenToChannel($selectedChannelId, (snapShot) => {
      if (snapShot.exists) {
        selected = { ...snapShot.data(), id: snapShot.id };
        ffList = selected.funFactList || [];
        tagList = selected.tagList || [];
        tagExList = selected.excludeTagList || [];
        sportsId = selected.sportsId || '';
        sportsPath = selected.sportsPath || '';
      }
    });
  };

  const onSaveFunFact = async () => {
    if (inputEl) {
      await updateProfileFunFactList($selectedChannelId, [
        ...ffList,
        { name: inputEl, id: inputEl },
      ]);
      inputEl = '';
    }
  };

  const onSaveTag = async () => {
    if (inputElTag) {
      await updateProfileTagList($selectedChannelId, [
        ...tagList,
        { name: inputElTag, id: inputElTag },
      ]);
      inputElTag = '';
    }
  };

  const onSaveExcludeTag = async () => {
    if (inputElExTag) {
      await updateProfileExcludeTagList($selectedChannelId, [
        ...tagExList,
        { name: inputElExTag, id: inputElExTag },
      ]);
      inputElExTag = '';
    }
  };

  const onSaveSportsId = async () => {
    if (inputElSportsId) {
      await updateProfileSportsIdText($selectedChannelId, inputElSportsId);
      // onSaveSportsId = '';
    }
  };

  const onSaveSportNamePath = async () => {
    if (inputElSportNamePath) {
      await updateProfileSportsNamePathText($selectedChannelId, inputElSportNamePath);
      // onSaveSportNamePath = '';
    }
  };

  const onDeleteFunFactClicked = async (e, funfact) => {
    e.stopPropagation();
    await removeMappingfunFact($selectedChannelId, funfact);
  };

  const onDeleteTagClicked = async (e, tag) => {
    e.stopPropagation();
    await removeMappingTag($selectedChannelId, tag);
  };

  const onDeleteExcludingTagClicked = async (e, tag) => {
    e.stopPropagation();
    await removeMappingExcludingTag($selectedChannelId, tag);
  };
</script>

<div>
  <div class="side-by-side">
    <div>
      <h2>Sports ID</h2>
      <div class="asset-input">
        <input disabled={false} class="input-box" bind:value={inputElSportsId} type="text" />
        <button disabled={false} class="add-button" on:click={onSaveSportsId}>Lagre</button>
      </div>
      {#if sportsId}
        <div class="list">
          <div class="list-item">
            {sportsId}
          </div>
        </div>
      {/if}
    </div>
    <div>
      <h2>Sports Path</h2>
      <div class="asset-input">
        <input disabled={false} class="input-box" bind:value={inputElSportNamePath} type="text" />
        <button disabled={false} class="add-button" on:click={onSaveSportNamePath}>Lagre</button>
      </div>
      {#if sportsPath}
        <div class="list">
          <div class="list-item">
            {sportsPath}
          </div>
        </div>
      {/if}
    </div>
  </div>
  <div class="side-by-side">
    <div>
      <h2>Profil Tags</h2>
      <div class="asset-input">
        <input disabled={false} class="input-box" bind:value={inputElTag} type="text" />
        <button disabled={false} class="add-button" on:click={onSaveTag}> + Ny Tag</button>
      </div>
      {#if tagList && tagList.length}
        <div class="list">
          {#each tagList as tag}
            <div class="list-item">
              {tag.name}
              <div class="btn-container">
                <button class="icon-button" on:click={(e) => onDeleteTagClicked(e, tag)}>
                  <span class="material-icons"> cancel </span>
                </button>
              </div>
            </div>
          {/each}
        </div>
      {/if}
    </div>
    <div>
      <h2>Exclude Tags</h2>
      <div class="asset-input">
        <input disabled={false} class="input-box" bind:value={inputElExTag} type="text" />
        <button disabled={false} class="add-button" on:click={onSaveExcludeTag}>
          + Ny exclude Tag</button
        >
      </div>
      {#if tagExList && tagExList.length}
        <div class="list">
          {#each tagExList as tag}
            <div class="list-item">
              {tag.name}
              <div class="btn-container">
                <button class="icon-button" on:click={(e) => onDeleteExcludingTagClicked(e, tag)}>
                  <span class="material-icons"> cancel </span>
                </button>
              </div>
            </div>
          {/each}
        </div>
      {/if}
    </div>
    <div class="fun-fact">
      <h2>Fun Fact</h2>
      <div class="asset-input">
        <input disabled={false} class="input-box" bind:value={inputEl} type="text" />
        <button disabled={false} class="add-button" on:click={onSaveFunFact}> + Ny Fun Fact</button>
      </div>
      {#if ffList && ffList.length}
        <div class="list">
          {#each ffList as funfact}
            <div class="list-item">
              {funfact.name}
              <div class="btn-container">
                <button class="icon-button" on:click={(e) => onDeleteFunFactClicked(e, funfact)}>
                  <span class="material-icons"> cancel </span>
                </button>
              </div>
            </div>
          {/each}
        </div>
      {/if}
    </div>
  </div>
</div>

<style src="./profile.scss"></style>
